import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../../../../me'
import * as variableOverrides from '../../../../../variable-overrides'
import * as currentRendering from '../../feature'

import { getActionsConfig } from './actions'
import { ApiService } from './api.service'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** TODO: Explain what is this */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ApiService} */
  public readonly api = ngCore.inject(ApiService)

  constructor(currentRenderingFeature: currentRendering.Feature) {
    const meFeature = ngCore.inject(me.Feature)
    const variablesFeature = ngCore.inject(variableOverrides.Feature)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Page',
      parent: currentRenderingFeature,
      selectors: () => new Selectors(this, meFeature, currentRenderingFeature),
    })

    this.registerEffects(
      effects.triggerPageRendering(currentRenderingFeature, variablesFeature),
      effects.getPageRenderOnRequest(),
    )
  }
}
